export type LoanType = "E2W" | "3 Wheeler";

interface LoanTypeBadgeProps {
  loanType?: LoanType | string | null;
  className?: string;
}

const LOAN_TYPE_STYLES: Record<string, string> = {
  e2w: "bg-emerald-100 text-emerald-800 border border-emerald-200 shadow-sm",
  "2w": "bg-emerald-100 text-emerald-800 border border-emerald-200 shadow-sm",
  "3 wheeler": "bg-amber-100 text-amber-800 border border-amber-200 shadow-sm",
  "3w": "bg-amber-100 text-amber-800 border border-amber-200 shadow-sm",
  l3: "bg-teal-100 text-teal-800 border border-teal-200 shadow-sm",
  "l3 goods": "bg-teal-100 text-teal-800 border border-teal-200 shadow-sm",
  "l3 passenger": "bg-teal-100 text-teal-800 border border-teal-200 shadow-sm",
  l4: "bg-sky-100 text-sky-800 border border-sky-200 shadow-sm",
  l5: "bg-violet-100 text-violet-800 border border-violet-200 shadow-sm",
  "l5 goods": "bg-violet-100 text-violet-800 border border-violet-200 shadow-sm",
  "l5 passenger": "bg-violet-100 text-violet-800 border border-violet-200 shadow-sm",
  battery: "bg-orange-100 text-orange-800 border border-orange-200 shadow-sm",
};

const toShortLoanType = (loanType: string): string => {
  const normalized = loanType.trim().toLowerCase();
  if (normalized === "e2w" || normalized === "2w") return "2W";
  if (normalized === "3 wheeler" || normalized === "3w") return "3W";
  if (normalized.includes("l3")) return "L3";
  if (normalized.includes("l4")) return "L4";
  if (normalized.includes("l5")) return "L5";
  if (normalized.includes("battery")) return "Battery";
  return loanType.trim();
};

const LoanTypeBadge = ({ loanType, className = "" }: LoanTypeBadgeProps) => {
  if (!loanType || String(loanType).trim() === "") {
    return null;
  }

  const rawValue = String(loanType).trim();
  const normalized = rawValue.toLowerCase();
  const style =
    LOAN_TYPE_STYLES[normalized] ??
    (normalized.includes("l3") ? "bg-teal-100 text-teal-800 border border-teal-200 shadow-sm" :
    normalized.includes("l4") ? "bg-sky-100 text-sky-800 border border-sky-200 shadow-sm" :
    normalized.includes("l5") ? "bg-violet-100 text-violet-800 border border-violet-200 shadow-sm" :
    normalized.includes("battery") ? "bg-orange-100 text-orange-800 border border-orange-200 shadow-sm" :
    "bg-gray-100 text-gray-800 border border-gray-200 shadow-sm");
  const displayLabel = toShortLoanType(rawValue);

  return (
    <span
      className={`inline-flex items-center px-2.5 py-1 rounded-full text-[11px] font-semibold tracking-wide ${style} ${className}`}
      title={`Product: ${displayLabel}`}
    >
      {displayLabel}
    </span>
  );
};

export default LoanTypeBadge;
